@if (featureSet) {
  <div class="container-fluid">
    <div class="row justify-content-start">
      <div class="col-md-8 col-xs-12">
        @switch (deviceType) {
          @case ('PIR') {
            <div class="left-graph-container">
              <div>
                <table class="detail-table">
                  <tr>
                    <th>Date</th>
                    <th>Status</th>
                  </tr>
                  @for (data of motionData; track data) {
                    <tr>
                      <td>{{data.displayTime}}</td>
                      <td>{{data.value === 1 ? 'Motion' : 'No Motion'}}</td>
                    </tr>
                  }
                </table>
              </div>
            </div>
          }
          @default {
            <div class="mt-3" name="timeSpan" aria-label="Time Span">
              <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'weekly' ? 'active' : ''" value="weekly" (click)="changeTimeSpan('weekly')">Weekly</mat-button-toggle>
              <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'monthly' ? 'active' : ''" value="monthly" (click)="changeTimeSpan('monthly')">Monthly</mat-button-toggle>
              <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'custom' ? 'active' : ''" value="custom" (click)="changeTimeSpan('custom')">Custom</mat-button-toggle>
            </div>
            @if (features) {
              <lds-feature-list [features]="features" [data]="features" deviceType="temperature" [productCode]="featureSet.productCode"></lds-feature-list>
            }
            @if (features) {
              <lds-y3-graph [data]="features" [startTime]="startTime" [endTime]="endTime" [timespan]="timespan" [features]="features" [deviceType]="deviceType"></lds-y3-graph>
            }
            <div class="below-graph">
              <button class="lds-btn" (click)="onExportClick()">Export Data</button>
            </div>
            <div class="below-graph-text">
              <p>Click and drag to zoom.</p>
            </div>
          }
        }
      </div>
      <div class="pl-md-0 col-md-4 pt-md-4 pt-3 col-xs-12 mb-2">
        <div class="info-container py-2 text-center mb-2">
          <div class="icon">
            <i [class]="icons.getIcon(featureSet.productCode)" [style.margin-left]="this.icon_margin"></i>
          </div>
          <div class="productcode-box">
            {{displayProductCode(featureSet.productCode)}}
          </div>
        </div>
        <div class="mx-2 mx-md-0">
          @if (deviceType === 'TRV') {
            <div class="pie-chart-container pt-2 mb-2">
              <div class="mx-4">Valve Total On Time</div>
              <hr class="mx-2 my-2">
              @if (totalOnData) {
                <lds-y3-donut-chart [deviceType]="deviceType" [data]="totalOnData"></lds-y3-donut-chart>
              }
            </div>
          }
          <div class="pie-chart-container bar-container pt-2 mb-2">
            <div class="mx-4">Daily Average temperature</div>
            <hr class="mx-2 my-2">
            @if (averageTempData) {
              <lds-y3-avg-daily-temp [data]="averageTempData"></lds-y3-avg-daily-temp>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
